import classes from './Inputs.module.css';
import { JsonInput, JsonInputProps } from '@mantine/core';
import { useResizeObserver } from '@mantine/hooks';
import { useCapabilityHelpLabel } from '@/pages/Editor/components/StepSidebar/CapabilityHelpContext.tsx';

type StyledJsonInputProps = JsonInputProps & { capabilityFieldId?: string };

const StyledJsonInput = ({ capabilityFieldId, ...props }: StyledJsonInputProps) => {
  const label = useCapabilityHelpLabel(props.label, capabilityFieldId);
  // for some reason, wrapping the text area in a div with a resize observer fixes the resizing issue
  const [containerRef] = useResizeObserver();

  return (
    <div ref={containerRef}>
      <JsonInput
        {...props}
        label={label}
        classNames={{
          input: classes.input,
          label: classes.label,
        }}
      />
    </div>
  );
};

export default StyledJsonInput;
